import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

import { CDSNode, Rule } from '../services/capd.model';
import { OrgService } from '../services/org.service';

@Component({
  selector: 'company-assign-rule',
  templateUrl: './company-assign-rule.component.html',
  // inputs: ['org', 'ruleToAdd']
})

/**
 * This component controls the modal used to assign a set of
 * rules to a selected set of user groups.
 */
export class CompanyAssignRuleComponent implements OnInit {
  @Output() update: EventEmitter<any> = new EventEmitter<any>();
  @Input() org: CDSNode;
  root: string;
  groupList: CDSNode[];
  groupToAdd: CDSNode[] = [];
  @Input() ruleToAdd: Rule[];

  constructor(private _service: OrgService) { }

/**
 * Gets the list of groups and sorts them.
 *
 * @async
 * @func ngOnInit
 */
  ngOnInit() {
    if (!!this.org.rootId) {
      this._service.getGroups(this.org).then((groups: CDSNode[]) =>
        this.groupList = groups.sort((a, b) => {
          const asplit = a.description.split(/\s?\/\s?/);
          const bsplit = b.description.split(/\s?\/\s?/);
          if (asplit.length - bsplit.length === 0) {
            let compareReturn = asplit[0].localeCompare(bsplit[0]);
            let i = 1;
            while (compareReturn === 0 && i < asplit.length) {
              compareReturn = asplit[i].localeCompare(bsplit[i]);
              i++;
            }
            return compareReturn;
          }
          else if (asplit.length < bsplit.length) {
              return -1;
          }
          else {
              return 1;
          }
        })
      );
      this.root = this.org.rootId;
    }
  }

  /**
   * Adds or removes a selected option to the list of groups to add rules to.
   *
   * @func updateChecked
   * @param {any} option - the option to add or remove.
   */
  updateChecked(option) {
    // Check to see if the option is in the array
    const index = this.groupToAdd.indexOf(option);
    // If it's not, add it to the end
    if (index < 0) {
      this.groupToAdd.push(option);
    }
    // Otherwise, remove it
    else {
      this.groupToAdd.splice(index, 1);
    }
  }

  /**
   * Confirms the list of groups and assigns the selected rules to the selected groups.
   *
   * @async
   * @func onSubmit
   */
  onSubmit() {
    this._service.assignRulesToGroup(this.ruleToAdd, this.groupToAdd, this.root).then(() => {
      this.groupToAdd = new Array(0); this.ruleToAdd = new Array(0); this.update.emit(null);
    });
  }

  /**
   * When the user cancels the action, clear the list of selected groups.
   *
   * @func onCancel
   */
  onCancel() {
    this.groupToAdd = [];
  }
}
